// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3I2vM","additionalInfo":"AgreementModal_additionalInfo___scRS"};